module.exports = __webpack_public_path__ + "img/STARTPACK.9c3242d7.jpeg";